import {
  UserMemberBean,
  UserMemberSubscriptionBeanWithMembership,
} from "@gymflow/types";
import { createContext } from "react";

export type OpenCancelMembershipSidebarOptions = {
  memberId: string;
  membership: UserMemberSubscriptionBeanWithMembership;
  linkedMembers: UserMemberBean[] | undefined;
};

interface CancelMembershipSidebarProviderContextType {
  openCancelMembershipSidebar: (
    values: OpenCancelMembershipSidebarOptions,
  ) => void;
}

const defaultContext: CancelMembershipSidebarProviderContextType = {
  openCancelMembershipSidebar: () => {
    throw new Error(
      "openCancelMembershipSidebar function must be used within CancelMembershipSidebarProviderProvider",
    );
  },
};

export const CancelMembershipSidebarProviderContext =
  createContext<CancelMembershipSidebarProviderContextType>(defaultContext);
